import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CandidateJobMatchesWorkflowActionsModalComponent } from './candidate-job-matches-workflow-actions-modal.component';
import { SetJobMatchStatusModule } from 'src/app/shared/job-match-actions/set-job-match-status/set-job-match-status.module';
import { AssignRecruiterModule } from 'src/app/shared/job-match-actions/assign-recruiter/assign-recruiter.module';
import { AddCandidatesModule } from 'src/app/pages/mission-control-page/add-candidates-page/add-candidates/add-candidates.module';
import { AssociateCandidatesModule } from '../associate-candidates/associate-candidates.module';
import { AddCandidatesFromJobBoardsModule } from '../add-candidates-from-job-boards/add-candidates-from-job-boards.module';
import { JobCandidatesCompareModule } from '../job-candidates-compare/job-candidates-compare.module';
import { JobProfileModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile/job-profile.module';
import { SendAssessmentModule } from 'src/app/shared/job-match-actions/send-assessment/send-assessment.module';
import { CancelAssessmentModule } from 'src/app/shared/job-match-actions/cancel-assessment/cancel-assessment.module';
import { MoveJobMatchStepModule } from 'src/app/shared/job-match-actions/move-job-match-step/move-job-match-step.module';

@NgModule({
  declarations: [CandidateJobMatchesWorkflowActionsModalComponent],
  imports: [
    CommonModule,
    SetJobMatchStatusModule,
    AssignRecruiterModule,
    AddCandidatesModule,
    AssociateCandidatesModule,
    AddCandidatesFromJobBoardsModule,
    JobCandidatesCompareModule,
    JobProfileModule,
    SendAssessmentModule,
    CancelAssessmentModule,
    MoveJobMatchStepModule
  ],
  exports: [CandidateJobMatchesWorkflowActionsModalComponent],
  entryComponents: [CandidateJobMatchesWorkflowActionsModalComponent]
})
export class CandidateJobMatchesWorkflowActionsModalModule { }
